import produce from 'immer'
import { SeccionfinanzasAction, SeccionfinanzasActionTypes } from '../actions/seccionfinanzasActions'
import { ApiStatus, ISeccionfinanzasItem } from '../models'

export const initialSeccionfinanzasState: ISeccionfinanzasState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  seccionfinanzas: [],
  foundseccionfinanzas: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function seccionfinanzasReducer(state: ISeccionfinanzasState = initialSeccionfinanzasState, action: SeccionfinanzasAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SeccionfinanzasActionTypes.SEARCH_SECCIONFINANZAS:
        draft.searchString = action.searchOptions.searchString
        break
      case SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case SeccionfinanzasActionTypes.SEARCHING_SECCIONFINANZAS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case SeccionfinanzasActionTypes.FOUND_SECCIONFINANZAS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundseccionfinanzas.push(...action.payload.seccionfinanzas.docs)
          : (draft.foundseccionfinanzas = action.payload.seccionfinanzas.docs)
        draft.totalDocs = action.payload.seccionfinanzas.totalDocs
        break

      case SeccionfinanzasActionTypes.LOAD_SECCIONFINANZAS:
      case SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundseccionfinanzas = []
        break

      case SeccionfinanzasActionTypes.LOADING_SECCIONFINANZAS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case SeccionfinanzasActionTypes.LOADED_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.seccionfinanzas = action.payload.seccionfinanzas.docs
        draft.totalDocs = action.payload.seccionfinanzas.totalDocs
        break

      case SeccionfinanzasActionTypes.ADD_SECCIONFINANZAS:
      case SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case SeccionfinanzasActionTypes.ADDING_SECCIONFINANZAS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionfinanzasActionTypes.ADDED_SECCIONFINANZAS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.seccionfinanzas.push(action.payload.seccionfinanzas.docs[0])
        if (draft.searchString) draft.foundseccionfinanzas.push(action.payload.seccionfinanzas.docs[0])
        break

      case SeccionfinanzasActionTypes.REMOVE_SECCIONFINANZA:
        draft.seccionfinanzas.splice(
          draft.seccionfinanzas.findIndex((seccionfinanza) => seccionfinanza._id === action.payload._id),
          1
        )
        break

      case SeccionfinanzasActionTypes.SOFT_REMOVE_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionfinanzasActionTypes.SOFT_REMOVED_SECCIONFINANZAS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionfinanzas.splice(
          draft.seccionfinanzas.findIndex((seccionfinanza) => seccionfinanza._id === action.payload._id),
          1
        )
        break

      case SeccionfinanzasActionTypes.SOFT_REMOVING_SECCIONFINANZAS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionfinanzasActionTypes.EDIT_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionfinanzasActionTypes.EDITED_SECCIONFINANZAS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionfinanzas[draft.seccionfinanzas.findIndex((seccionfinanza) => seccionfinanza._id === action.payload._id)] = action.payload
        draft.foundseccionfinanzas[draft.foundseccionfinanzas.findIndex((seccionfinanza) => seccionfinanza._id === action.payload._id)] =
          action.payload
        break

      case SeccionfinanzasActionTypes.EDITING_SECCIONFINANZAS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ISeccionfinanzasState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  seccionfinanzas: ISeccionfinanzasItem[]
  foundseccionfinanzas: ISeccionfinanzasItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
